import { Component, effect, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { filter, startWith, Subject, takeUntil } from 'rxjs';
import { IntroService } from '../../features/admin/home/services/intro.service';
import { ProductCompareService } from '../../features/admin/product/services/compare-product.service';
import { SearchRecommenderComponent } from './components/search-recommender/search-recommender.component';

@Component({
    selector: 'app-admin-layout',
    standalone: false,
    templateUrl: './admin-layout.component.html',
    styleUrl: './admin-layout.component.scss',
})
export class AdminLayoutComponent implements OnDestroy, OnInit {
    @ViewChild('scrollContainer') scrollContainer!: ElementRef<HTMLElement>;

    protected hideFooter = false;
    protected isDetailPage = false;
    protected isScrolled = false;
    protected showCompareProduct = false;
    protected introFinished = false;

    private componentInstance$ = new Subject<void>();
    private previousUrl: string | null = null;

    constructor(
        private activatedRoute: ActivatedRoute,
        private matDialog: MatDialog,
        private msalService: MsalService,
        private productCompareService: ProductCompareService,
        private router: Router,
        private introService: IntroService,
    ) {
        effect(() => {
            if (this.introService.introFinished()) {
                this.introFinished = true;
            }
        });
    }

    @HostListener('window:scroll')
    onWindowScroll(): void {
        if (this.matDialog.openDialogs.length > 0) {
            return;
        }

        this.isScrolled = window.scrollY > 20;
    }

    ngOnInit(): void {
        this.msalService.initialize();
        this.subscribeToRouteChanges();
        this.checkCompareProductId();
    }

    ngOnDestroy(): void {
        this.componentInstance$.next();
        this.componentInstance$.complete();
    }

    protected onSearch(): void {
        this.matDialog.open(SearchRecommenderComponent, {
            maxHeight: '90vh',
            maxWidth: '90vw',
            panelClass: 'search-recommender',
            width: '45rem',
        });
    }

    private subscribeToRouteChanges(): void {
        this.router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd),
                startWith(null),
                takeUntil(this.componentInstance$),
            )
            .subscribe(() => {
                let currentRoute = this.activatedRoute;
                const routeUrl = this.router.url;

                if (routeUrl === '/home' && this.previousUrl !== '/home') {
                    this.introService.introFinished.set(false);
                    this.introFinished = false;
                } else {
                    this.introFinished = true;
                }

                this.productCompareService.clear();

                while (currentRoute.firstChild) {
                    currentRoute = currentRoute.firstChild;
                }

                const data = currentRoute.snapshot.data;

                this.hideFooter = !!data['hideFooter'];
                this.isDetailPage = !!data['isDetailPage'];
                this.previousUrl = routeUrl;
            });
    }

    private checkCompareProductId(): void {
        this.productCompareService.selectedIds$.pipe(takeUntil(this.componentInstance$)).subscribe({
            next: (ids) => {
                this.showCompareProduct = !!ids.length;
            },
        });
    }
}
